<template>
  <page-wrapper v-bind="pageWrapper">
    <div class="row requested-package-detail-page">
      <div class="col-4 package">
        <h2 class="title">Package</h2>
        <div v-if="pack" class="package-detail">
          <div class="row mb-2">
            <div class="col-sm-12 col-lg-4">
              <img :src="pack.coverUrl" class="img-fluid d-block mb-2" />
            </div>
            <div class="col-sm-12 col-lg-8">
              <p>ชื่อ</p>
              <div class="mb-2">{{ pack.name }}</div>
              <p>ราคา</p>
              <div class="mb-2">{{ pack.price }}</div>
              <p>รอบบิล</p>
              <div class="mb-2">{{ pack.billingCycle }}</div>
            </div>
          </div>
          <p>บริการ</p>
          <service-list-item
            v-for="service in pack.services"
            v-bind="service"
            :key="service.id"
            class="service"
          ></service-list-item>
        </div>
      </div>
      <div class="col-8 request-list">
        <h2 class="title">Requested ({{ totalRequested }})</h2>
        <p v-if="list.length" class="total-count">{{ totalCount }} โครงการ</p>
        <div
          v-for="requested in requestedList"
          :key="requested.key"
          class="requested"
        >
          <div class="number">
            <h4 class="title">{{ requested.numberOfRequested }}</h4>
            <p class="subtitle">คำร้อง</p>
          </div>
          <div class="project">{{ requested.project }}</div>
          <div class="actions">
            <sc-button
              variant="primary"
              size="sm"
              @click="handleClickDoneButton(requested.deleteParams)"
              >จัดการแล้ว</sc-button
            >
            <sc-button :route="requested.route" variant="secondary" size="sm"
              >เพิ่ม Package</sc-button
            >
          </div>
        </div>
        <div v-if="list.length" class="wrapper small text-end mt-4">
          <el-pagination
            :total="total"
            :page-size="10"
            :current-page="queryParams.page"
            background
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
        <p v-if="!list.length" class="text-center">ไม่มีข้อมูล</p>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies"
import PageWrapper from "@/lib/components/PageWrapper"
import ScButton from "@/lib/components/ScButton"
import { formatCurrencyAndTwoDecimalsString } from "@/lib/formatter"
import { toCamelCaseObject } from "@/lib/util"
import { Pagination as ElPagination } from "element-ui"
import ServiceListItem from "../../services/components/ServiceListItem"

export default {
  components: {
    ElPagination,
    PageWrapper,
    ScButton,
    ServiceListItem,
  },
  data() {
    const selectedPackage = null
    const list = []
    const total = 0
    const totalRequested = 0

    return {
      selectedPackage,
      list,
      total,
      totalRequested,
    }
  },
  computed: {
    pageWrapper() {
      return {
        title: "Requested Package Detail",
        hasPad: true,
      }
    },
    totalCount() {
      const limit = 10
      const currentTotalItem = this.list.length
      const isLastPage = limit > currentTotalItem
      const currentPage = this.queryParams.page
      const end = isLastPage ? this.total : currentPage * limit
      const start = (isLastPage ? limit * currentPage - limit : end - limit) + 1

      return `แสดงผล ${start.toLocaleString()} - ${end.toLocaleString()} จากทั้งหมด ${this.total.toLocaleString()}`
    },
    requestedList() {
      return this.list.map((item, index) => {
        const key = index
        const project = `${item.projectCode} ${item.projectName}`
        const numberOfRequested = item.requestCount
        const { projectId } = item
        const deleteParams = { projectId, packageId: this.packageId }
        const route = {
          name: "PackageCreatePage",
          query: { id: this.packageId, projectId },
        }

        return { key, project, numberOfRequested, route, deleteParams }
      })
    },
    pack() {
      if (!this.selectedPackage) {
        return null
      }

      const { name } = this.selectedPackage
      const price = `${formatCurrencyAndTwoDecimalsString(
        this.selectedPackage.price / 100,
      )} บาท`
      const billingCycle = `${this.selectedPackage.billing_cycle.toLocaleString()} เดือน`
      const coverUrl = this.selectedPackage.image_url
      const pack = {
        name,
        price,
        billingCycle,
        coverUrl,
      }

      const services = this.selectedPackage.services.map((service) => {
        const {
          id,
          name: serviceName,
          short_description: shortDescription,
          description,
        } = service
        const provider = {
          ...service.provider,
          logoUrl: service.provider.logo_url,
        }

        return {
          id,
          name: serviceName,
          shortDescription,
          description,
          provider,
        }
      })

      pack.services = services

      return pack
    },
    packageId() {
      return this.$route.params.id
    },
    queryParams() {
      return {
        page: Number(this.$route.query.page) || 1,
      }
    },
  },
  watch: {
    "$route.query": "setupData",
  },
  mounted() {
    this.setupData()
  },
  methods: {
    async setupData() {
      await Promise.all([
        this.setupDataSelectedPackage(),
        this.setupDataList(),
      ])
    },
    async setupDataList() {
      const { requestPackages, count, total } = await this.fetchList()
      this.list = requestPackages
      this.total = count
      this.totalRequested = total
    },
    async setupDataSelectedPackage() {
      this.selectedPackage = await this.fetchPackage()
    },
    async fetchPackage() {
      const response =
        await baanRueJaiClient.admin.subscriptions.recommend_packages.get(
          this.packageId,
        )

      return response.data.result
    },
    async fetchList() {
      const response =
        await baanRueJaiClient.admin.subscriptions.recommend_packages.getRequestPackageDetail(
          this.packageId,
          this.queryParams,
        )

      return toCamelCaseObject(response.data.result)
    },
    handleCurrentChange(page) {
      this.$router.replace({ query: { ...this.$route.query, page } })
    },
    async handleClickDoneButton(params) {
      try {
        await baanRueJaiClient.admin.subscriptions.recommend_packages.deleteRequestProjectPackage(
          params,
        )

        this.$message.success("จัดการเรียบร้อย")

        if (this.queryParams.page > 1) {
          this.$router.replace({ query: { ...this.$route.query, page: 1 } })
          return
        }

        this.setupDataList()
      } catch {
        this.$message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง")
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 2rem;
}

.wrapper.small {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.requested-package-detail-page {
  .title {
    font-size: 1.25rem;
    margin-bottom: 2rem;
  }

  .total-count {
    margin-top: -1rem;
    margin-bottom: 2rem;
  }

  .service {
    padding-left: 0;
    padding-right: 0;
  }

  .package {
    border-right: 1px solid #ddd;
  }

  .requested {
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: 70px 1fr 200px;
    align-items: center;

    padding: 0.5rem 0;

    > .number {
      font-size: 1rem;

      > .title,
      > .subtitle {
        margin: 0;
        text-align: center;
        line-height: 1.4;
      }

      > .subtitle {
        font-size: 0.75rem;
        color: #888;
      }
    }

    > .project {
      font-size: 0.875rem;
    }
  }
}
</style>
